import getQueryParamsFromUrl from './getQueryParamsFromUrl'
import getUTMParamsFromQuery from './getUTMParamsFromQuery'

const getUTMParamsFromUrl = (url) => {
  return getUTMParamsFromQuery(getQueryParamsFromUrl(url))
}
export default getUTMParamsFromUrl
